import { alertAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const {
  definePartsStyle: defineAlertPartsStyle,
  defineMultiStyleConfig: defineAlertMultiStyleConfig,
} = createMultiStyleConfigHelpers(alertAnatomy.keys);

const baseStyleAlert = defineAlertPartsStyle({
  container: {
    borderRadius: "var(--chakra-radii-md)", //'4px',
  },
});

const components = {
  Button: {
    defaultProps: {
      colorScheme: "primary",
      focusBorderColor: "primary.600",
    },
    variants: {
      primary: {
        bg: "primary.400",
        color: "primary.900",
        _hover: {
          bg: "primary.700",
          color: "primary.50",
        },
        _dark: {
          bg: "primary.200",
          color: "primary.900",
          _hover: {
            bg: "primary.400",
          },
        },
      },
    },
  },
  Switch: {
    defaultProps: {
      colorScheme: "primary",
      focusBorderColor: "primary.600",
    },
  },
  Checkbox: {
    defaultProps: {
      colorScheme: "primary",
      focusBorderColor: "primary.600",
    },
  },
  Input: {
    defaultProps: {
      colorScheme: "primary",
      focusBorderColor: "primary.600",
    },
  },
  Select: {
    defaultProps: {
      colorScheme: "primary",
      focusBorderColor: "primary.600",
    },
  },
  CUIAutocomplete: {
    listStyleProps: {
      bg: "gray.800",
      pt: "4",
      colorScheme: "primary",
      focusBorderColor: "primary.600",
    },
  },
  NumberInput: {
    defaultProps: {
      colorScheme: "primary",
      focusBorderColor: "primary.600",
    },
  },
  Tag: {
    defaultProps: {
      colorScheme: "primary",
    },
  },
  Alert: defineAlertMultiStyleConfig({ baseStyle: baseStyleAlert }),
};

export { components };
